module.exports = __webpack_public_path__ + "img/homebackgroundimg.da879a93.jpg";